export const objectStoreName = {
    areaStoreName: 'areas',
    branchStoreName: 'branches',
    loanOfficerStoreName: 'loanOfficers',
    loanProductStoreName: 'loanProducts',
    depositProductStoreName: 'depositProducts',
}